import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo
} from 'react';
import * as DatasourceAPI from '../Api/datasource';
import React from 'react';
export const DatasourceContext = createContext();
export const useDatasource = () => useContext(DatasourceContext);

export const DatasourceProvider = ({
  children
}) => {
  const [initialLoad, setInitialLoad] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [datasources, setDatasources] = useState([]);


  const refreshDatasources = useCallback(async() => {
    if(localStorage.getItem("auth_token") !== null){
      try {
          setError();
          setLoading(true);
          const data = await DatasourceAPI.getAllDatasources();
          setDatasources(data);
          return data;
      } catch (error) {
          setError(error);
      } finally {
          setLoading(false)
      }
    }
  }, []);




  useEffect(() => {
      if (!initialLoad) {
        refreshDatasources();
        setInitialLoad(true);
      }
  }, [initialLoad, refreshDatasources]);

  const value = useMemo(() => ({
      refreshDatasources,
      datasources,
      error,
      loading,
  }), [refreshDatasources,datasources, error, loading]);

  return ( <DatasourceContext.Provider value = {value} > {
          children
      } </DatasourceContext.Provider>
  );
};